//intended to be used with urls that come from S3

import { httpClient } from "infra/axios/axios-api";
import Spinner from "presentation/components/Shared/Spinner";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import MobilePDFViewer from "../MobilePDFViewer";

interface MobileS3PEFViewerDialogProps {
    s3Path: string;
    onHide: () => void
}

const MobileS3PDFViewerDialog = ({s3Path, onHide}: MobileS3PEFViewerDialogProps) => {
    const [internalPdfUrl, setInternalPdfUrl] = useState<string | null>(null);
    const [isLoadingPdf, setIsLoadingPdf] = useState(false);
    const [errorPdf, setErrorPdf] = useState<string | null>(null);
    const [fileName, setFileName] = useState<string>("");

    useEffect(() => {
        let objectUrl: string | null = null;

        const fetchPdf = async () => {
            if (s3Path) {
            setIsLoadingPdf(true);
            setErrorPdf(null);
            setInternalPdfUrl(null); // Garante que o PDF antigo não é exibido durante o carregamento
            const splitS3Path = s3Path.split("/");
            const s3FileName = splitS3Path[splitS3Path.length - 1];

            setFileName(s3FileName);

            try {
            
                const fileStreamResponse = await httpClient.get(
                `/assets/download/${s3Path}`,
                {
                    responseType: "blob",
                }
                );

                const pdfBlob = new Blob([fileStreamResponse.data], {
                type: "application/pdf",
                });
                objectUrl = URL.createObjectURL(pdfBlob);
                setInternalPdfUrl(objectUrl);
            } catch (err) {
                console.error("Erro ao carregar PDF do S3:", err);
                setErrorPdf("Não foi possível carregar o PDF.");
            } finally {
                setIsLoadingPdf(false);
            }
            }
        };

        fetchPdf();

        return () => {
            if (objectUrl) {
            URL.revokeObjectURL(objectUrl);
            }
        };
    }, [s3Path]);

    const handleHide = () => {
        onHide();
    };

    return (
        <Dialog
        header="Visualizador de Relatório"
        visible={!!s3Path}
        style={{ width: "70vw", height: "90vh" }}
        maximized
        onHide={handleHide}
        contentClassName="flex flex-column justify-content-center"
        contentStyle={{backgroundColor: "#ebebeb"}}
        >
        {isLoadingPdf && <Spinner />}
        {errorPdf && <div className="p-error">{errorPdf}</div>}
        {!isLoadingPdf && !errorPdf && internalPdfUrl && (
            <MobilePDFViewer url={internalPdfUrl} fileName={fileName} />
        )}
        {!isLoadingPdf && !s3Path && <div>Nenhum PDF para exibir.</div>}
        </Dialog>
    );


}

export default MobileS3PDFViewerDialog;